import { render } from "./Explorer.vue?vue&type=template&id=4a8dbfc7&scoped=true"
import script from "./Explorer.vue?vue&type=script&lang=js"
export * from "./Explorer.vue?vue&type=script&lang=js"

import "./Explorer.vue?vue&type=style&index=0&id=4a8dbfc7&scoped=true&lang=css"

import exportComponent from "/builds/fLte45evJ/0/trinax/jeopardy.trinax.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8dbfc7"]])

export default __exports__